module.exports = __webpack_public_path__ + "static/media/step2img3.2d9afccf.PNG";